// Zeitsteuerung für Aktions-LPs. Läuft im Browser statt in Liquid, weil Shopify Seiten
// zwischenspeichert und ein Datumswechsel sonst erst verspätet sichtbar würde.
// Zeitpunkte kommen als Unix-Sekunden (Liquid-Filter date: '%s').
// Block-Scope: Die Datei kann mehrfach eingebunden sein (eine Section pro Vorkommen).
{
  // Zeigt den Inhalt nur zwischen data-start und data-end (beides optional).
  class LpScheduled extends HTMLElement {
    connectedCallback() {
      // Im Theme-Editor bleibt der von Liquid gerenderte Zustand, damit alles bearbeitbar ist.
      if (window.Shopify?.designMode) return;
      this.start = Number(this.dataset.start) * 1000 || -Infinity;
      this.end = Number(this.dataset.end) * 1000 || Infinity;
      this.update();
    }

    update() {
      const now = Date.now();
      this.hidden = now < this.start || now >= this.end;
      const nextChange = now < this.start ? this.start : this.end;
      if (Number.isFinite(nextChange) && nextChange > now) {
        clearTimeout(this.timer);
        // setTimeout verträgt maximal ~24 Tage, danach reicht ein erneuter Check.
        this.timer = setTimeout(() => this.update(), Math.min(nextChange - now + 50, 2 ** 31 - 1));
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }
  }

  // Zählt bis data-target herunter und schreibt Tage/Stunden/Minuten/Sekunden in [data-unit].
  class LpCountdown extends HTMLElement {
    connectedCallback() {
      this.target = Number(this.dataset.target) * 1000;
      this.units = Object.fromEntries([...this.querySelectorAll('[data-unit]')].map((el) => [el.dataset.unit, el]));
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const seconds = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
      const values = {
        days: Math.floor(seconds / 86400),
        hours: Math.floor((seconds % 86400) / 3600),
        minutes: Math.floor((seconds % 3600) / 60),
        seconds: seconds % 60,
      };
      for (const [unit, el] of Object.entries(this.units)) {
        el.textContent = String(values[unit]).padStart(2, '0');
      }
      if (seconds === 0) clearInterval(this.interval);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }

  if (!customElements.get('lp-scheduled')) customElements.define('lp-scheduled', LpScheduled);
  if (!customElements.get('lp-countdown')) customElements.define('lp-countdown', LpCountdown);
}
